/**
 * The demo tenant lives in the same database as real data, in one fixed workspace
 * (see ans-backend lib/demoConstants.ts). The front end only needs the id, to label
 * the session so demo is never mistaken for real data.
 */
export const DEMO_WORKSPACE_ID = '11111111-1111-1111-1111-111111111111';

export function isDemoWorkspaceId(id: string | null | undefined): boolean {
  return typeof id === 'string' && id.toLowerCase() === DEMO_WORKSPACE_ID;
}
